export default __webpack_public_path__ + "static/media/shopping-3.034dbf24.png";